import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../hooks/useLanguage';

// Sidebar inspirado en Dashui (simplificado). Recibe estado colapsado desde App.
const Sidebar = React.forwardRef(({ collapsed, mobileHidden = false, onNavigate }, ref) => {
    const { hasModule, modules } = useAuth();
    const { t } = useLanguage();

    return (
        <aside
            ref={ref}
            id="primary-navigation"
            className={`app-sidebar ${collapsed ? 'collapsed' : ''}`}
            aria-hidden={mobileHidden || undefined}
            inert={mobileHidden || undefined}
            aria-label={t('sidebar.label')}
        >
            <div className="sidebar-inner d-flex flex-column h-100">
                <nav className="nav-section" aria-label={t('sidebar.navigation')}>
                    <div className="nav-heading small text-uppercase fw-semibold text-muted px-3 mb-2">{t('sidebar.sections.main')}</div>
                    <ul className="nav flex-column mb-3">
                        <li className="nav-item">
                                <NavLink to="/" end onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.home')} title={t('sidebar.menu.home')}>
                                <i className="bi bi-house-door" aria-hidden="true"></i>
                                <span className="link-text">{t('sidebar.menu.home')}</span>
                            </NavLink>
                        </li>
                    </ul>
                    <div className="nav-heading small text-uppercase fw-semibold text-muted px-3 mb-2">{t('sidebar.sections.modules')}</div>
                    <ul className="nav flex-column mb-3">
                        {hasModule(1) && (
                            <li className="nav-item">
                                <NavLink to="/module/regulations" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.policyNavigator')} title={t('sidebar.menu.policyNavigator')}>
                                    <i className="bi bi-compass" aria-hidden="true"></i>
                                    <span className="link-text">{t('sidebar.menu.policyNavigator')}</span>
                                </NavLink>
                            </li>
                        )}
                        {hasModule(2) && (
                            <li className="nav-item">
                                <NavLink to="/module/journals" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.journalFinder')} title={t('sidebar.menu.journalFinder')}>
                                    <i className="bi bi-journal-text" aria-hidden="true"></i>
                                    <span className="link-text">{t('sidebar.menu.journalFinder')}</span>
                                </NavLink>
                            </li>
                        )}
                        {hasModule(7) && (
                            <li className="nav-item">
                                <NavLink to="/module/concursos" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.contestNavigator')} title={t('sidebar.menu.contestNavigator')}>
                                    <i className="bi bi-award" aria-hidden="true"></i>
                                    <span className="link-text">{t('sidebar.menu.contestNavigator')}</span>
                                </NavLink>
                            </li>
                        )}
                    </ul>
                    {(modules.some(m => m.url === 'mantenimiento/editoriales') || modules.some(m => m.url === 'mantenimiento/revistas')) && (
                        <>
                            <div className="nav-heading small text-uppercase fw-semibold text-muted px-3 mb-2">{t('sidebar.sections.maintenance')}</div>
                            <ul className="nav flex-column mb-3">
                                {modules.some(m => m.url === 'mantenimiento/editoriales') && (
                                    <li className="nav-item">
                                        <NavLink to="/mantenimiento/editoriales" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.publishers')} title={t('sidebar.menu.publishers')}>
                                            <i className="bi bi-building" aria-hidden="true"></i>
                                            <span className="link-text">{t('sidebar.menu.publishers')}</span>
                                        </NavLink>
                                    </li>
                                )}
                                {modules.some(m => m.url === 'mantenimiento/revistas') && (
                                    <li className="nav-item">
                                        <NavLink to="/mantenimiento/revistas" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.journals')} title={t('sidebar.menu.journals')}>
                                            <i className="bi bi-journal-text" aria-hidden="true"></i>
                                            <span className="link-text">{t('sidebar.menu.journals')}</span>
                                        </NavLink>
                                    </li>
                                )}
                                {modules.some(m => m.url === 'mantenimiento/concursos') && (
                                    <li className="nav-item">
                                        <NavLink to="/mantenimiento/concursos" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.contests')} title={t('sidebar.menu.contests')}>
                                            <i className="bi bi-award" aria-hidden="true"></i>
                                            <span className="link-text">{t('sidebar.menu.contests')}</span>
                                        </NavLink>
                                    </li>
                                )}
                            </ul>
                        </>
                    )}
                    {(modules.some(m => m.url === 'seguridad/accesos') || modules.some(m => m.url === 'seguridad/usuarios')) && (
                        <>
                            <div className="nav-heading small text-uppercase fw-semibold text-muted px-3 mb-2">{t('sidebar.sections.security')}</div>
                            <ul className="nav flex-column mb-3">
                                {modules.some(m => m.url === 'seguridad/accesos') && (
                                    <li className="nav-item">
                                        <NavLink to="/seguridad/accesos" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.accessManagement')} title={t('sidebar.menu.accessManagement')}>
                                            <i className="bi bi-shield-lock" aria-hidden="true"></i>
                                            <span className="link-text">{t('sidebar.menu.accessManagement')}</span>
                                        </NavLink>
                                    </li>
                                )}
                                {modules.some(m => m.url === 'seguridad/usuarios') && (
                                    <li className="nav-item">
                                        <NavLink to="/seguridad/usuarios" onClick={onNavigate} className="nav-link d-flex align-items-center gap-2" aria-label={t('sidebar.menu.userManagement')} title={t('sidebar.menu.userManagement')}>
                                            <i className="bi bi-people" aria-hidden="true"></i>
                                            <span className="link-text">{t('sidebar.menu.userManagement')}</span>
                                        </NavLink>
                                    </li>
                                )}
                            </ul>
                        </>
                    )}
                </nav>
                <div className="mt-auto small px-3 py-3 text-muted sidebar-footer">
                    <div>© {new Date().getFullYear()} {t('app.name')}</div>
                </div>
            </div>
        </aside>
    );
});

Sidebar.displayName = 'Sidebar';

export default Sidebar;
